import { Modal, Button } from '@elsevier/graphene'
import { Typography } from '@elsevier/eds-core'
import React from 'react'

interface errorModalProps {
  isOpen: boolean
  errorInfo: {
    title: string
    detail: string
  }
  closeModal: () => void
}

export default function ModalError({
  isOpen,
  errorInfo,
  closeModal,
}: errorModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) closeModal()
      }}
      role="alertdialog"
      mainTitle={errorInfo.title}
      closeButtonAriaLabel="Close error dialog"
      elementIDToFocusOnClose="request-content-inventory"
      primaryButton={
        <Button variant="primary" label="Close" onClick={closeModal} />
      }
    >
      {/* Modal puts data-* attributes on its trigger wrapper outside the
          dialog, so the automation hook lives on the body content instead. */}
      <Typography
        data-feature="request-error-modal"
        as="p"
        fontSize="body-medium"
      >
        {errorInfo.detail}
      </Typography>
    </Modal>
  )
}
